import React from 'react';
import { hydrate } from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import routes from './routes';
import App from './App';
const data = window._INITIAL_DATA_;
hydrate(React.createElement(BrowserRouter, null,
    React.createElement(App, { routes: routes, serverLoadedData: data })), document.getElementById('root'));
if (module.hot) {
    module.hot.accept();
}
//# sourceMappingURL=client.js.map